import { ADD_TO_COMPARE_LIMIT } from '@neptune/compare-domain';
import { plural } from '@neptune/shared/common-util';

import { addNotification } from 'state/ui/global/notification-popup/actions';

/**
 * @param itemsCount - Number of items. If omitted, defaults to plural form.
 */
export function createCompareLimitReachedNotification(itemsCount = 0) {
  const itemTerm = plural(itemsCount, {
    one: 'Item was',
    other: 'One or more items were',
  });

  return addNotification(
    'error',
    `Comparison limit reached (${ADD_TO_COMPARE_LIMIT}). ${itemTerm} not selected.`,
  );
}
